import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetPermissionList = () => {
  const [loading, setLoading] = useState(true);
  const [permissionList, setPermissionList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getPermissionList = ({ Term, Guid, Page, Count }) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/Permission/List', {
        params: {
          Term: Term || '',
          Guid: Guid || '',
          Page: Page || 1,
          Count: Count || 100,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setPermissionList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              name: element.name,
              display: element.display,
            }));

            return {
              ...prev,
              [Page || 1]: orderedList,
            };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getPermissionList, loading, permissionList, pageRef };
};

export { useGetPermissionList };
